import FactoryComponents from '../../../factory/components/FactoryComponents.js';
import { getCompanyInfo } from '../../../api/common';
import { getCode, changePassWord } from "@/api/login"
import {loginTxzk} from "@/api/api";
import { getStorage,setStorage,removeStorage } from "@/utils/localStorage";
const root = {}
export default root
root.name = 'login';
root.data = {
  loginForm: {username: '', pass: ''},
  dialogVisible: false,
  form: {
    account: '',
    phone: '',
    code: '',
    password: '',
    verifyPassword: ''
  },
  codeBtnWord: '获取验证码',
  codeBtnStatus: false, // 获取验证码的按钮状态
  timer: null, // 倒计时的定时器
  rules: {
    account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    verifyPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  }
};
root.created = function() {
  if(this.$route.query.username && this.$route.query.password) {
    this.$set(this.loginForm, 'username', this.$route.query.username)
    this.$set(this.loginForm, 'pass', this.$route.query.password)
    this.onLogin()
  }
},
root.methods = {
  findBackPassword: function(){
    this.$alert('请联系管理员', '提示', {
      confirmButtonText: '确定'
    })
  },
  // 重置密码
  resetPassword() {
    this.dialogVisible = true
  },
  // 关闭弹窗
  handleClose() {
    this.$refs['form'].resetFields();
  },
  // 点击获取验证码按钮的事件
  getCodeBtn() {
    if(this.form.account === "" || this.form.phone === "") {
      this.$message.error('请输入手机号和账号')
      return
    }
    getCode({account: this.form.account,phone: this.form.phone}).then(res => {
      this.codeBtnWord = 60
      this.codeBtnStatus = true
      this.timer = setInterval(() => {
        this.codeBtnWord -= 1
        if(this.codeBtnWord === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.codeBtnWord = "获取验证码"
          this.codeBtnStatus = false
        }
      },1000)
    })
  },
  // 提交修改密码的表单
  submitForm() {
    this.$refs['form'].validate((valid) => {
      if (valid) {
        changePassWord({...this.form}).then(res => {
          this.$message.success('修改成功，请登录')
          this.dialogVisible = false
        })
      } else {
        return false;
      }
    });
  },
  convertImage: function(url) {
    return require('../../../assets/img' + url);
  },
  withTimeout(promise, timeout = 4000) {
    let timer = null;
    const wrappedPromise = promise.then(value => {
      if (timer) {
        clearTimeout(timer);
      }
      return value;
    }).catch(err => {
      if (timer) {
        clearTimeout(timer);
      }
      throw err;
    });
    return Promise.race([
      wrappedPromise,
      new Promise(resolve => {
        timer = setTimeout(() => resolve(null), timeout);
      })
    ]);
  },
  // 公司信息和第三方定位登录不再阻塞登录人信息；远程接口慢时最多等待几秒后继续进入系统。
  loadCompanyInfoAfterLogin(timeout = 4000) {
    const companyInfoPromise = getCompanyInfo().then(info => {
      const companyList = info && info.body && info.body.data;
      if(Array.isArray(companyList) && companyList.length > 0){
        const infos = companyList[0];
        setStorage('companyInfo', JSON.stringify(infos));
        if (infos.serviceIp) {
          loginTxzk().then(res => {
            if (res.data.code === 200) {
              setStorage("txzkToken","Bearer "+res.data.data.access_token)
            }
          }).catch(err => {
            console.error('第三方定位系统登录失败', err)
          })
        }
        return true;
      }
      return false;
    }).catch(err => {
      console.error('获取公司信息失败', err)
      return false;
    })
    return this.withTimeout(companyInfoPromise, timeout);
  },
  async loadLoginUserInfo() {
    const res = await this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').userInfo).closeLoad().startGet();
    const userInfo = res && res.body && res.body.data;
    if (!userInfo) {
      throw new Error('用户信息为空');
    }
    setStorage('userInfo', JSON.stringify(userInfo))
    setStorage('userId', userInfo.id)
    setStorage('empId', userInfo.empId)
    setStorage('manufacturer', userInfo.dbName)
  },
  onLogin: function(formName){
    if(this.loginForm.username === ''){
      this.$message.error('请输入用户名');
      return;
    }
    if(this.loginForm.pass === ''){
      this.$message.error('请输入密码');
      return;
    }
    let num = JSON.parse(getStorage('num'))
    if(!num) {
      num = 0
    }
    let formdata = new FormData();
    formdata.append("username", this.loginForm.username);
    formdata.append("password", this.loginForm.pass);
    formdata.append("device",'pc');
    if(num !== 5){
      this.componentsMoudel.startPost(this.componentsMoudel.getData('urls').loginUrl, formdata, false).then(async (res) => {
        removeStorage('appToken')
        removeStorage("companyInfo");
        const companyInfoTask = this.loadCompanyInfoAfterLogin(4000);

        try {
          await this.loadLoginUserInfo();
        } catch (err) {
          console.error('获取登录人信息失败', err)
          this.$message.error('登录成功，但获取登录人信息失败，请检查远程路由会话配置后重试')
          return;
        }

        if (res.body.data == "master") {
          this.$router.push({path: '/mainAdmin'})
          setStorage("num", 0)
        } else {
          this.$router.push({path: '/home'})
          setStorage("num", 0)
        }
        //登录成功，跳转到home节目
        this.$message({
          message: '登录成功',
          type: 'success'
        });
      });
    }else{
      this.$message.error('操作过于频繁，请稍后再试')
      let nowtime = Date.parse(new Date());
      let time = JSON.parse(getStorage('time'))
      let a = (nowtime - time) / 1000
      if(a > 20) {
        setStorage("num", 0)
      }
    }
  }
},

  FactoryComponents.initComponent(root);
